import { useMutation } from "@tanstack/react-query";
//import { CognitoRefreshToken, CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import { forgotPassword } from "@/pages/Authentication/AuthUtils/ForgotPassword"

export const useForgotPassword=()=>{
    return useMutation({
        mutationFn:forgotPassword
    })
}
